import { siteCodes } from '../models/siteCodes';
export default new class chatBotService {
    getSiteCodeByName(name: string): number | undefined {
        const normalizedInput = name.trim().toLowerCase();
        const site = siteCodes.find(s => s.name.trim().toLowerCase() === normalizedInput);
        return site?.code;
    }
}